export default function installWoodmartSideCartFocusFix() {
  const IPP_ID = "inpostpay-widget-popup";
  const WOODMART_SIDE_CART_SELECTOR = ".cart-widget-side";
  const WOODMART_BODY_CLASSES = [
    "wp-theme-woodmart",
    "theme-woodmart",
  ];
  const PENDING_MS = 8000;

  let active = false;
  let guardInterval = null;
  let pendingUntil = 0;

  const hasIppPopup = () => Boolean(document.getElementById(IPP_ID));

  const isWoodmartTheme = () => {
    if (!document.body || !document.body.classList) return false;

    return WOODMART_BODY_CLASSES.some((className) => {
      return document.body.classList.contains(className);
    });
  };

  const start = () => {
    if (window.__ipp_woodmart_side_cart_focus_fix_installed) return;
    if (!isWoodmartTheme()) return;

    window.__ipp_woodmart_side_cart_focus_fix_installed = true;

    const originalFocus = HTMLElement.prototype.focus;

    const isWoodmartSideCart = (element) => {
      return (
        element &&
        element.classList &&
        element.classList.contains("cart-widget-side") &&
        element.classList.contains("wd-side-hidden") &&
        element.querySelector(".widget_shopping_cart_content")
      );
    };

    const isOpenedWoodmartSideCart = (element) => {
      return (
        isWoodmartSideCart(element) &&
        element.classList.contains("wd-opened")
      );
    };

    const getWoodmartSideCarts = () => {
      return Array.from(document.querySelectorAll(WOODMART_SIDE_CART_SELECTOR))
        .filter(isWoodmartSideCart);
    };

    const getOpenedWoodmartSideCarts = () => {
      return getWoodmartSideCarts().filter(isOpenedWoodmartSideCart);
    };

    const isIppButtonClick = (event) => {
      const path = event.composedPath ? event.composedPath() : [];

      return path.some((element) => {
        return element && element.tagName && element.tagName.toLowerCase() === "inpost-izi-button";
      });
    };

    const armPendingGuard = () => {
      pendingUntil = Date.now() + PENDING_MS;
    };

    const shouldBlockFocus = () => {
      return active || hasIppPopup() || Date.now() < pendingUntil;
    };

    HTMLElement.prototype.focus = function (...args) {
      if (shouldBlockFocus() && isWoodmartSideCart(this)) {
        return;
      }

      return originalFocus.apply(this, args);
    };

    document.addEventListener(
      "click",
      (event) => {
        if (isIppButtonClick(event)) {
          armPendingGuard();
        }
      },
      true,
    );

    const applyBlock = () => {
      getOpenedWoodmartSideCarts().forEach((element) => {
        element.style.setProperty("pointer-events", "none", "important");
      });
    };

    const clearBlock = () => {
      getWoodmartSideCarts().forEach((element) => {
        element.style.removeProperty("pointer-events");
      });
    };

    const enable = () => {
      if (active) return;
      if (!hasIppPopup()) return;
      if (!getWoodmartSideCarts().length) return;

      active = true;

      applyBlock();

      if (!guardInterval) {
        guardInterval = window.setInterval(() => {
          if (!hasIppPopup()) {
            disable();
            return;
          }

          applyBlock();
        }, 200);
      }
    };

    const disable = () => {
      if (!active) return;

      active = false;
      pendingUntil = 0;

      if (guardInterval) {
        window.clearInterval(guardInterval);
        guardInterval = null;
      }

      clearBlock();
    };

    const observer = new MutationObserver(() => {
      if (hasIppPopup()) {
        enable();
      } else {
        disable();
      }
    });

    observer.observe(document.body, { childList: true, subtree: true });

    if (hasIppPopup()) {
      enable();
    }
  };

  if (document.body) {
    start();
  } else {
    document.addEventListener("DOMContentLoaded", start, { once: true });
  }
}
